module.exports = __webpack_public_path__ + "static/img/th.b42cf653.gif";